import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { fCurrencyUSD } from '@/utils/formatNumber';
import { useWatch } from 'react-hook-form';
import { FormSchemaCreate } from './type';
import { useGetSpecAndPricingInstanceGPU } from '@/service/one-click-deploy/hook';
import dayjs from 'dayjs';
import { fDate } from '@/utils/formatTime';

const DisplayPricing = () => {
  const { instance } = useWatch<FormSchemaCreate>();
  const { data } = useGetSpecAndPricingInstanceGPU();
  const result = data?.find((item) => item.pricing_id === instance?.gpu);
  const isDiscounted = result?.isDiscounted;
  const pricing = result?.price || 0;
  const originalPrice = result?.originalPrice || 0;

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>Pricing Summary</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid gap-1">
            <p>
              <span className="text-muted-foreground"> Estimated cost: </span>
              {isDiscounted && (
                <>
                  <span className="text-muted-foreground line-through">
                    ${originalPrice}
                  </span>{' '}
                  <span className="text-base">&#8594;</span>
                </>
              )}{' '}
              <span className="text-base font-semibold">
                {fCurrencyUSD(pricing)} / hr
              </span>
            </p>
            {result?.isDiscounted && result?.ineffective_date && (
              <p>
                <span className="text-muted-foreground">Discount until: </span>
                <span className="font-medium">{fDate(result?.ineffective_date)}</span>
              </p>
            )}
          </div>
        </CardContent>
      </Card>
    </>
  );
};

export default DisplayPricing;
